import React, { Component } from 'react'
import { connect } from 'react-redux'
// import isWindows from 'is-windows'

import Button from './UI/Button'
import Toggle from './UI/Toggle'
import ModalAlertDialog from './ModalAlertDialog'

import tooltips from '../constants/tooltips.json'
import factoryResetMessage from "../constants/factoryResetMessage";

import {
  setAutoLearnMode,
  setUseLearnModeSound,
  requestAllDeviceData,
  resetLearnModeRecords,
  exportBarDataToJSON,
  openLearnModeTour,
  learnModeFactoryReset
} from '../actions'

class LearnModeOptions extends Component {
  state = {
    resetBtnDisabled: false,
    resetModalOpen: false
  };

  handleFactoryResetCallback = (response) => {
    switch (response) {
      case 'ok':
        this.props.onLearnModeFactoryReset();
        break;
      case 'cancel':
        // nothing
        break;
    
      default:
        break;
    }
    // close modal
    this.setState({ resetModalOpen: false });
  };

  render() {
    const {
      onSetAutoMode,
      onSetLearnModeSounds,
      onResetLearnModeRecords,
      onRequestDeviceData,
      learnModeRecording,
      learnModeAuto,
      learnModeUseSounds,
      showTooltips,
    } = this.props;

    return (
      <div className="learn-mode-options">
        <h3>Options</h3>
        <div
          className="auto-learn-mode-toggle"
          data-tip={tooltips["learn-mode-toggle-auto-mode"]}
          data-multiline="true"
          data-place="left"
          data-tip-disable={!showTooltips}
        >
          <label>Auto Mode</label>
          <Toggle
            checked={!!learnModeAuto}
            disabled={learnModeRecording}
            onChange={(event) => onSetAutoMode(~~event.target.checked)}
          />
        </div>
        <div
          className="learn-mode-sound-toggle"
          data-tip={tooltips["learn-mode-toggle-sound"]}
          data-multiline="true"
          data-place="left"
          data-tip-disable={!showTooltips}
        >
          <label>Use Sounds</label>
          <Toggle
            checked={!!learnModeUseSounds}
            onChange={(event) => onSetLearnModeSounds(~~event.target.checked)}
          />
        </div>
        <div className="buttons-reset-export-set">
          {false && (
            <Button
              name="Reset"
              data-tip={tooltips["learn-mode-button-reset"]}
              data-multiline="true"
              data-place="top"
              data-type="info"
              data-tip-disable={false}
              disabled={this.state.resetBtnDisabled || learnModeRecording}
              onClick={() => {
                this.setState({
                  resetBtnDisabled: true,
                });
                setTimeout(() => {
                  this.setState({
                    resetBtnDisabled: false,
                  });
                }, 5000);

                onResetLearnModeRecords();
                onRequestDeviceData();
              }}
            />
          )}
          <Button
            name="Export Data"
            data-tip={tooltips["learn-mode-button-export-data"]}
            data-multiline="true"
            data-place="top"
            data-tip-disable={!showTooltips}
            onClick={() => {
              this.props.onExportBarData();
            }}
          />
          <Button
            name="Open Tour"
            data-tip={tooltips["learn-mode-button-open-tour"]}
            data-multiline="true"
            data-place="left"
            data-tip-disable={!showTooltips}
            onClick={() => {
              this.props.onOpenLearnModeTour(true);
            }}
          />
        </div>
        <Button
          name="Sensitivity Reset"
          data-tip={tooltips["learn-mode-button-sensitivity-reset"]}
          data-multiline="true"
          data-place="top"
          data-tip-disable={!showTooltips}
          onClick={() => {
            this.setState({ resetModalOpen: true });
          }}
        />
        <ModalAlertDialog
          open={this.state.resetModalOpen}
          message={factoryResetMessage}
          parentCallback={this.handleFactoryResetCallback}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    learnModeRecording: state.editor.learnModeRecording,
    learnModeAuto: state.editor.learnModeAuto,
    learnModeUseSounds: state.editor.learnModeUseSounds,
    showTooltips: state.editorPreferences.showTooltips
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    onSetAutoMode: (autoMode) => {
      dispatch(setAutoLearnMode(autoMode))
    },
    onSetLearnModeSounds: (useSounds) => {
      dispatch(setUseLearnModeSound(useSounds))
    },
    onResetLearnModeRecords: () => {
      dispatch(resetLearnModeRecords())
    },
    onRequestDeviceData: () => {
      dispatch(requestAllDeviceData())
    },
    onExportBarData: () => {
      dispatch(exportBarDataToJSON())
    },
    onOpenLearnModeTour: (state) => {
      dispatch(openLearnModeTour(state))
    },
    onLearnModeFactoryReset: () => {
      dispatch(learnModeFactoryReset());
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LearnModeOptions)
